import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import KioskApp from "@/kiosk/KioskApp";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import SolutionsAdmin from "@/admin/SolutionsAdmin";
import IndustriesAdmin from "@/admin/IndustriesAdmin";
import MediaAdmin from "@/admin/MediaAdmin";
import LeadsAdmin from "@/admin/LeadsAdmin";
import SettingsAdmin from "@/admin/SettingsAdmin";
import UsersAdmin from "@/admin/UsersAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<KioskApp />} />
            <Route path="/kiosk" element={<KioskApp />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="solutions" element={<SolutionsAdmin />} />
              <Route path="industries" element={<IndustriesAdmin />} />
              <Route path="media" element={<MediaAdmin />} />
              <Route path="leads" element={<LeadsAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
              <Route path="users" element={<UsersAdmin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
